var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.06462 5.56C3.89838 4.12104 5.22668 3.03412 6.80218 2.50163C8.37769 1.96914 10.093 2.02736 11.6288 2.66546C13.1646 3.30356 14.4161 4.47805 15.1504 5.97023C15.8846 7.46242 16.0516 9.1706 15.6201 10.7767C15.1887 12.3828 14.1882 13.7774 12.8051 14.7008C11.4219 15.6242 9.75034 16.0135 8.10155 15.7961C6.45276 15.5787 4.93914 14.7696 3.84254 13.5193C2.74594 12.269 2.1411 10.6628 2.14062 8.99972",
    stroke: "#6C757D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.42857 5.5692H3V2.14062",
    stroke: "#6C757D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/reset.56caa423991dc45809d7d0206c5fc0d2.svg";
export { ForwardRef as ReactComponent };